export default "assets/images/icons/download-0fe62856.svg";